import { useQuery } from "react-query";
import { getVendors } from "../../../../actions/CarrierAgreementMgmt/BusinessLicensesAndPermits";

export const useGetVendors = () => {
  return useQuery("GetVendors", getVendors, {
    refetchOnWindowFocus: false,
  });
};
